import { gql, useQuery } from '@apollo/client';

import { useTranslation } from 'react-i18next';
import { lobbyGameFragment } from '../../../../graphql/fragments';
import { ActiveGames } from '../../../../graphql/types';

import GameTable from './GameTable';

const GameList = () => {
  const [t] = useTranslation();
  const { data, loading, error } = useQuery<ActiveGames>(activeGamesQuery, {
    fetchPolicy: 'cache-and-network',
  });

  if (data != null) {
    return data.activeGames.length > 0 ? (
      <GameTable games={data.activeGames} />
    ) : (
      <p>{t('gameList.withoutGames', 'Doposud nebyla započata žádná hra.')}</p>
    );
  }

  if (error != null) {
    return <p>{error.message}</p>;
  }

  if (loading) {
    return <p>{t('GameList.loading', 'Loading...')}</p>;
  }

  return null;
};

export default GameList;

export const activeGamesQuery = gql`
  query ActiveGames {
    activeGames {
      ...LobbyGame
    }
  }
  ${lobbyGameFragment}
`;
